/**
 * Converts a base64-encoded GraphQL cursor to its corresponding number in a browser environment.
 * Assumes the cursor encodes a numeric value, possibly with an offset or transformation.
 * @param cursor The base64-encoded cursor string (e.g., 'MA==' for 1, 'MQ==' for 2).
 * @returns The decoded number, or throws an error if invalid.
 */
export function cursorToNumber(cursor: string): number {
	try {
		// Decode the base64 cursor using atob (browser-compatible)
		const decoded = atob(cursor);

		// Attempt to parse the decoded string as a number
		const number = parseInt(decoded, 10);

		// Check if the result is a valid number
		if (isNaN(number)) {
			throw new Error('Decoded cursor is not a valid number');
		}

		// Apply offset (e.g., MA== decodes to '0' but represents 1)
		return number + 1; // Adjust based on your cursor encoding logic
	} catch (error) {
		throw new Error(`Invalid cursor format: ${(error as Error).message}`);
	}
}
